import type { CommonSettingsType } from "../../../../../common-deprecated/settings/fetchCommonSettings";
import type { BnbSettingsType } from "../../redux/reducers/BnbSettingsReducer";
import type { BuildAndBuyDispatchType } from "../../redux/store";
import { NavStep, navStepsOrder } from "../../../shared-logic/utils/Navigation";
import { type BuildAndBuyLabelType, nextLabels } from "../../utils/labels";
import { showServicesStep } from "../../utils/settings/bnbSettingUtils";
import { trackNavGoToStep } from "../../utils/tracking";
import useStepUrl from "./actions/useStepUrl";

type BasketCtaProps = {
    step: NavStep;
    bnbSettings: BnbSettingsType;
    commonSettings: CommonSettingsType;
    dispatch: BuildAndBuyDispatchType;
};

type BasketCtaReturnType = {
    nextTarget: NavStep;
    nextUrl: string;
    nextLabel: BuildAndBuyLabelType;
    onNextClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const useBasketCta = (props: BasketCtaProps): BasketCtaReturnType => {
    const { bnbSettings, commonSettings } = props;
    const { step } = props;

    const showServices = showServicesStep(bnbSettings, commonSettings);

    let nextTarget = navStepsOrder[navStepsOrder.indexOf(step) + 1];
    if (!showServices && nextTarget === NavStep.Services) {
        // Skip when services step is disabled
        nextTarget = NavStep.Summary;
    }
    const { href: nextUrl, onClick } = useStepUrl(nextTarget);
    const nextLabel = nextLabels[nextTarget]!;

    const onNextClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        trackNavGoToStep(step, nextTarget);
        onClick(event);
    };

    return {
        nextTarget,
        nextUrl,
        nextLabel,
        onNextClick,
    };
};
export default useBasketCta;
